<div class="plumes_calc_card" [class.plumes_calc_card-active]="isActive || isLoading">
    <div *ngIf="isActive" class="plumes_calc_card__is_now">
        {{ nowOnMapText }}
    </div>

    <ca-spinner *ngIf="isLoading" class="plumes_calc_card__spin" color="#6097F3"></ca-spinner>

    <ng-content></ng-content>
</div>
